module.exports = __webpack_public_path__ + "img/building.bda56df8.jpg";